import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { isInAppBrowser, isIos, isMobileApp } from "@/utils/browser";
import { analyticsService } from "@/services/analytics";

export function InAppBrowserBlocker() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isMobileApp()) return;
    if (!isInAppBrowser()) return;

    // Laisse l'utilisateur parcourir l'app 12 secondes avant d'afficher le message
    const timer = setTimeout(() => {
      setVisible(true);
      analyticsService.trackEvent("in_app_browser_hint_shown", {
        user_agent: window.navigator.userAgent,
      });
    }, 12000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          className="fixed inset-x-3 bottom-24 z-[60] mx-auto max-w-[28rem] rounded-2xl bg-card p-4 shadow-2xl ring-1 ring-border"
        >
          <div className="flex items-start gap-3">
            <div
              className="grid size-10 shrink-0 place-items-center rounded-xl text-lg"
              style={{ background: "rgba(59,130,246,0.15)", color: "#0052cc" }}
            >
              📲
            </div>
            <div className="min-w-0 grow">
              <p className="text-sm font-semibold tracking-tight">
                Pour installer l’app
              </p>
              <p className="mt-0.5 text-[11px] leading-relaxed text-muted-foreground">
                Ouvre ce lien dans {isIos() ? "Safari" : "Chrome"} pour profiter de la meilleure expérience.
              </p>
              <button
                onClick={() => {
                  setVisible(false);
                  analyticsService.trackEvent("in_app_browser_hint_dismissed");
                }}
                className="mt-2 text-[11px] font-semibold"
                style={{ color: "#0052cc" }}
              >
                Merci, plus tard
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
